import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./motion";

const FAQS = [
  {
    q: "Will it taste like mushrooms?",
    a: "Nope. God Mode is built on a smooth medium-dark arabica roast. The functional mushrooms are odorless and tasteless in the blend — you get real coffee flavor with an upgraded engine underneath.",
  },
  {
    q: "How is this different from regular coffee?",
    a: "Regular coffee spikes then crashes you. God Mode pairs a lower, cleaner caffeine dose with Lion's Mane, Cordyceps and Chaga so your focus and energy climb and hold for 6+ hours — without jitters or the 2pm collapse.",
  },
  {
    q: "How does Subscribe & Save work?",
    a: "Pick your supply, keep the subscription toggle on, and save an extra 10% on every delivery. It ships automatically each month, you can skip, pause or cancel anytime in one click — no phone calls, no games.",
  },
  {
    q: "What about shipping?",
    a: "For our launch, shipping is 100% FREE on every order — no minimum, no games. Every bag ships fast from the USA.",
  },
  {
    q: "How much caffeine is in it?",
    a: "About 120mg per 12oz cup — roughly one strong coffee, but delivered smoothly alongside adaptogenic mushrooms so it lands as calm, sustained focus instead of a spike.",
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="border-t border-zinc-800 bg-surface-100"
    >
      <div className="mx-auto max-w-[1000px] px-5 py-24 sm:px-8 sm:py-32">
        <Reveal>
          <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.3em] text-blaze">
            FAQ
          </p>
          <h2 className="font-display text-5xl uppercase leading-[0.9] tracking-tight sm:text-7xl">
            Questions?
            <br />
            <span className="text-zinc-600">Answered.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12 w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-zinc-800"
              >
                <AccordionTrigger className="py-6 text-left font-display text-xl uppercase tracking-tight text-white hover:text-blaze hover:no-underline sm:text-2xl">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-zinc-400">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
